// Distrito Federal
const df = [{ data: '5300108', label: 'Brasília' }];

export default df;
